import { useEffect } from 'react';
export function useIntersectionObserver(element, options, callback) {
    useEffect(() => {
        const target = element.current;
        if (!target) {
            return;
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => callback(entry, () => observer.unobserve(target)));
        }, options);
        observer.observe(target);
        return () => {
            observer.disconnect();
        };
    }, [element, callback]);
}
